import { AllBuyerConfigSettings } from '../interfaces/buyer-config.interface';

export class BuyerConfigSettingsVerifier {
  constructor(private readonly _buyerConfig: AllBuyerConfigSettings) {}

  /**
   * Checks if the given `configSetting` is enabled for the company with the given `companyId`.
   * @param configSetting - The key from the `AllBuyerConfigSettings` object to check.
   * @param companyId - The id of the company to check.
   * @returns {boolean} - `true` if the `configSetting` is enabled for the company, `false` otherwise.
   */
  public verifyPermission(
    configSetting: keyof AllBuyerConfigSettings,
    companyId: number
  ): boolean {
    return this._buyerConfig[configSetting].includes(companyId);
  }
}
